export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ACCESS_PENDING = 'ACCESS_PENDING',
  LOGIN_BLOCKED = 'LOGIN_BLOCKED',
  PASSWORD_RESET = 'PASSWORD_RESET'
}
